import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Checkbox } from '@mui/material';
import { Column } from 'primereact/column';
import moment from 'moment';
import { StyledBoxTable } from '../../../components/layout/main/mainStyles';
import { LoadingRowsComponent } from '../../../components/commons/LoadingRows/LoadingRows';
import { styledColumnHeaderCheckbox } from '../../../components/layout/main/mainStyles';
import { ShippingOrderTemplateProps } from './shippingOrderTemplateProps';

export const ShipipngOrderTemplate = ({
  isLoading,
  isSuccess,
  allShippingOrder,
  selectedItems,
  setSelectedItems
}: ShippingOrderTemplateProps) => {
  const getHeaderCheckbox = () => {
    return (
      <Checkbox
        className="p-checkbox"
        style={{
          visibility: selectedItems.length ? 'visible' : 'hidden'
        }}
        checked={
          (allShippingOrder && selectedItems && selectedItems.length > 0) ??
          false
        }
        onChange={() => {
          setSelectedItems([]);
        }}
      />
    );
  };
  const getFormattedDate = (rowData: { shippingDate: string }) => {
    if (rowData.shippingDate) {
      return moment(rowData.shippingDate).format('MM/DD/YYYY HH:MM');
    }
    return '';
  };
  return (
    <StyledBoxTable>
      {isLoading && <LoadingRowsComponent />}
      {isSuccess && allShippingOrder && (
        <DataTable
          selectionMode="multiple"
          metaKeySelection
          selection={selectedItems}
          value={allShippingOrder ?? []}
          size="small"
          scrollable
          scrollHeight="flex"
          onSelectionChange={(e) => setSelectedItems(e.value)}
          paginator={allShippingOrder && allShippingOrder.length >= 50}
          selectionPageOnly
          rows={50}
          rowsPerPageOptions={[5, 10, 20, 50]}
          tableStyle={{ padding: 0, margin: 0, fontSize: '14px' }}
          className="mt-3"
          rowHover
        >
          <Column
            selectionMode="multiple"
            headerStyle={styledColumnHeaderCheckbox}
            header={getHeaderCheckbox}
            frozen
          />
          <Column field="soNumber" header="SO Number" sortable />
          <Column
            field="shippingDate"
            header="Shipping Date"
            sortable
            body={getFormattedDate}
          />
        </DataTable>
      )}
    </StyledBoxTable>
  );
};
